import React from 'react';

const Body = props => <div className="px-4 space-y-4" {...props} />;

export default Body;
